const D =
  "M0 24 h34 l6 -6 l6 6 h12 l6 -18 l7 34 l6 -22 l5 6 h26 l6 -6 l6 6 h12 l6 -18 l7 34 l6 -22 l5 6 h84";

const LiveSignal = ({ className = "", color = "#A19A9D" }) => (
  <svg
    viewBox="0 0 240 48"
    className={className}
    aria-hidden="true"
    fill="none"
    preserveAspectRatio="none"
  >
    <path d={D} stroke="#2A2026" strokeWidth="1" />
    <path
      d={D}
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      className="trace-scan"
    />
  </svg>
);

export default LiveSignal;
